export default __webpack_public_path__ + "static/media/pooja-joshi.bbc443ed.jpg";